import React from 'react';
import { HistoryHeader, HistoryHeaderEach } from './HistoryStyles';
import { useTranslation } from '../../locale/context';

function HistoryTabs({
	handleCurrentData,
	history,
	activeSubPage,
	setActiveSubPage
}: any) {
	const { t } = useTranslation();

	const tabs = [
		{ title: t('common.history.tab.myBets'), active: 'my' },
		{ title: t('common.history.tab.allBets'), active: 'all' },
		{ title: t('common.history.tab.highRolls'), active: 'high' }
	];

	return (
		<HistoryHeader>
			{tabs.map((item, id) => (
				<HistoryHeaderEach
					key={id}
					isActive={activeSubPage === item.active}
					onClick={() => {
						setActiveSubPage(item.active);
						handleCurrentData(history[item.active]);
					}}
				>
					{item.title}
				</HistoryHeaderEach>
			))}
		</HistoryHeader>
	);
}

export default React.memo(HistoryTabs);
